<template>
  <div v-if="!hide" :class="['guide-message', { hiding }]">
    <p>
      <slot />
    </p>
    <el-button round type="text" class="button" @click="onGotIt">Got it</el-button>
  </div>
</template>

<script lang="ts">
import Cookies from 'js-cookie'

export default {
  name: 'GuideMessage',
  props: {
    messageId: { type: String, default: null },
  },
  data: function () {
    const messagesToHide = this.getMessages()
    return {
      hide: messagesToHide.includes(this.messageId),
      hiding: false,
    }
  },
  methods: {
    getMessages() {
      const cookie = Cookies.get('guide_messages_to_hide')
      return cookie ? JSON.parse(cookie) : []
    },
    onGotIt() {
      const messagesToHide = this.getMessages()
      messagesToHide.push(this.messageId)
      Cookies.set('guide_messages_to_hide', messagesToHide)
      this.hiding = true
      setTimeout(() => (this.hide = true), 2000)
    },
  },
}
</script>

<style scoped lang="scss">
.guide-message {
  width: 400px;
  max-width: calc(100% - 30px);
  min-height: 64px;
  height: fit-content;
  border: 0;
  -webkit-box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  box-shadow: 0 5px 35px 0 rgba(154, 161, 171, 0.3);
  border-radius: 0;
  border-left: 8px solid #2f94d0;
  padding: 16px 16px 32px;
  position: relative;
  animation: animateInFromRight 2s;

  .button {
    position: absolute;
    bottom: 0;
    right: 32px;
  }
}

.guide-message ~ * {
  margin-left: 32px;
}

.hiding {
  animation: animateOut 0.5s ease-in forwards;
}

@keyframes animateInFromRight {
  from {
    transform: translateX(300px);
    opacity: 0;
  }

  50% {
    transform: translateX(300px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 100;
  }
}

@keyframes animateOut {
  from {
    transform: translateX(0px);
    opacity: 100;
  }

  to {
    transform: translateX(500px);
    opacity: 0;
  }
}
</style>
